import clsx from "clsx"
import { FC, MouseEventHandler, TouchEventHandler, useState } from "react"
import style from "./Tooltip.module.css"

export type TooltipPosition = "tooltip-top" | "tooltip-right" | "tooltip-bottom" | "tooltip-left"

type TooltipProps = {
  children: JSX.Element | JSX.Element[]
  tooltipPosition: TooltipPosition
  title: string
  width?: "fit" | "full"
  className?: string
  display?: boolean
  tooltipUseMinWidth?: boolean
}

export const Tooltip: FC<TooltipProps> = ({
  children,
  tooltipPosition,
  title,
  width = "full",
  className,
  display = true,
  tooltipUseMinWidth = true,
}) => {
  if (!display) {
    return <>{children}</>
  }

  const [isVisible, setIsVisible] = useState(false)

  const handleMouseEnter: MouseEventHandler<HTMLDivElement> = () => {
    setIsVisible(true)
  }

  const handleMouseLeave: MouseEventHandler<HTMLDivElement> = () => {
    setIsVisible(false)
  }

  const handleTouchStart: TouchEventHandler<HTMLDivElement> = () => {
    setIsVisible(true)
  }

  const handleTouchEnd: TouchEventHandler<HTMLDivElement> = () => {
    setIsVisible(false)
  }

  return (
    <div
      className={clsx(
        className,
        style["tooltip-parent"],
        width === "fit" ? style["tooltip-fit"] : style["tooltip-full"]
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchEnd}
    >
      {children}
      {isVisible && (
        <TooltipItem
          title={title}
          tooltipPosition={tooltipPosition}
          tooltipUseMinWidth={tooltipUseMinWidth}
        />
      )}
    </div>
  )
}

type TooltipItemProps = {
  title: string
  tooltipPosition: TooltipPosition
  tooltipUseMinWidth: boolean
}

const TooltipItem: FC<TooltipItemProps> = ({ title, tooltipPosition, tooltipUseMinWidth }) => {
  return (
    <div
      className={clsx(
        style["tooltip-container"],
        style[tooltipPosition],
        tooltipUseMinWidth && style["tooltip-use-min-width"]
      )}
    >
      <p className={style["tooltip-title"]}>{title}</p>
    </div>
  )
}
